export default "__VITE_ASSET__C7X523O2__"